import { useClientTheme } from "@/app/components/ThemeContext"

// "Blake Sowle" -> "BS". Falls back to the first two characters of a
// single-word name. Names are nullable (a user can be invited without one),
// so guard against null/undefined rather than crashing on `.trim()`.
export function userInitials(name: string | null | undefined): string {
  const words = (name ?? "").trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return ""
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

/**
 * Circular user avatar: renders the uploaded image when `avatarUrl` is present,
 * otherwise a solid brand-fill initials disc (the header's original styling).
 */
export function UserAvatar({
  name,
  avatarUrl,
  size = 28,
}: {
  name: string | null | undefined
  avatarUrl?: string | null
  size?: number
}) {
  const { theme } = useClientTheme()
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name ?? ""}
        className="rounded-full flex-shrink-0 object-cover"
        style={{ width: size, height: size }}
      />
    )
  }
  return (
    <div
      className="flex items-center justify-center rounded-full flex-shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: theme.brandPrimary,
        color: theme.textOnBrand,
        fontFamily: "var(--font-ui)",
        fontSize: Math.round(size * 0.43),
        fontWeight: 700,
      }}
    >
      {userInitials(name)}
    </div>
  )
}
